// Znovunačtení reklamy
export const reloadAds = () => {
  if (typeof window.__cncAdsReload !== 'undefined') window.__cncAdsReload();
};
